/*
 * Este archivo administra la carga de plugins y la inicialización de las aplicaciones Vue
 * específicas según el contexto de la página. Utiliza imports dinámicos para que solo se cargue
 * el código JS necesario dependiendo de si existen ciertos elementos en el DOM.
 *
 * - Si existe un div con id "sucursal-app", se carga e inicializa la app de sucursales.
 * - Si existe un div con id "mex-app", se carga e inicializa la app de mex.
 * - Si existe un div con id "call-app", se carga e inicializa la app de call center.
 *
 * De esta forma, se optimiza la carga de recursos y se evita cargar JS innecesario en páginas donde no se requiere.
 */
/* globals Vue */
import "./bootstrap";

// Plugins compartidos en la red de atención
import Buefy from 'buefy'
import Vuebar from "vuebar";
import Sticky from "vue-sticky-directive";
import ScrollToTopButton from "./apps/components/ScrollToTopButton.vue";

Vue.use(Buefy)
Vue.use(Vuebar);
Vue.use(Sticky);
Vue.component("ScrollToTopButton", ScrollToTopButton);

// Cargar la app específica dependiendo del contexto
if (document.getElementById("sucursal-app")) {
  require("./apps/sucursal/sucursal-app");
}

if (document.getElementById("mex-app")) {
  require("./apps/mex/mex-app");
}

if (document.getElementById("call-app")) {
  require("./apps/call-center/call-app");
}

if (document.getElementById("redes-atencion-app")) {
  require("./apps/redes-atencion/redes-atencion-app");
}

if (document.getElementById("faq-app")) {
  require("./apps/faq/faq-app");
}